interface PropsI {
	onClick?: () => void
}
export const MenuIcon: React.FC<PropsI> = ({ onClick }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='19'
			onClick={onClick}
			className='menuicon-svg'
			viewBox='0 0 24 19'>
			<g id='Group_4988' data-name='Group 4988' transform='translate(-336 -55)'>
				<rect
					id='Rectangle_1397'
					data-name='Rectangle 1397'
					width='24'
					height='3'
					rx='1.5'
					transform='translate(336 55)'
					fill='#7a719b'
				/>
				<rect
					id='Rectangle_1398'
					data-name='Rectangle 1398'
					width='24'
					height='3'
					rx='1.5'
					transform='translate(336 63)'
					fill='#7a719b'
				/>
				<rect
					id='Rectangle_1399'
					data-name='Rectangle 1399'
					width='24'
					height='3'
					rx='1.5'
					transform='translate(336 71)'
					fill='#7a719b'
				/>
			</g>
		</svg>
	)
}
